import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { formatCurrency } from '../../utils/expenseUtils';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-xl px-3 py-2 shadow-warm-md border border-surface-200 text-sm">
      <p className="font-semibold text-ink-800">{label}</p>
      <p className="text-ink-500">{formatCurrency(payload[0].value)}</p>
    </div>
  );
};

const SpendingTrend = ({ data, dateRange }) => {
  if (!data?.length) return null;

  const isWeekly = dateRange === 'this_month' || dateRange === 'last_3';

  // Use short labels for small screens, full labels for large
  const chartData = data.map(d => ({
    ...d,
    displayLabel: d.shortLabel,
  }));

  return (
    <div className="card p-6">
      <h3 className="font-bold text-ink-900 text-[0.9375rem] mb-5">{isWeekly ? 'Weekly' : 'Monthly'} Spending Trend</h3>

      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={chartData} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
          <defs>
            <linearGradient id="gradientCanopy" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#1B6B4A" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#1B6B4A" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e0d6" vertical={false} />
          <XAxis
            dataKey="displayLabel"
            tick={{ fontSize: 12, fill: '#57534e' }}
            axisLine={{ stroke: '#e5e0d6' }}
            tickLine={false}
          />
          <YAxis
            tickFormatter={(v) => `$${v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v}`}
            tick={{ fontSize: 12, fill: '#57534e' }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="total"
            stroke="#1B6B4A"
            strokeWidth={2.5}
            fill="url(#gradientCanopy)"
            animationDuration={1000}
            dot={{ fill: '#1B6B4A', strokeWidth: 2, r: 4, stroke: 'white' }}
            activeDot={{ r: 6, fill: '#3BA676', stroke: 'white', strokeWidth: 2 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SpendingTrend;
